<template>
    <div
        class="iconBase"
        :class="[
            color && `iconBase-${color}`
         ]"
    >
        <slot>
            <i :class="name"></i>
        </slot>
    </div>
</template>


<script>
import IconBocalVide from '../views/components/icons/bocalVide.vue'
import IconBalance from '../views/components/icons/balance.vue'
export default {
  name: 'principe',
  components: {
    IconBocalVide,
    IconBalance,
  },
}
</script>